import React from 'react';
import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { USER_TYPE_ADMIN, USER_TYPE_WAREHOUSE } from '../types/auth/types';

const ProtectedRoute = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  if (user) {
    const redirectPath =
      user.user_type === USER_TYPE_ADMIN || user.user_type === USER_TYPE_WAREHOUSE ? '/home/vehicles' : '/home';
    return <Navigate to={redirectPath} />;
  } else if (!user) {
    return <Navigate to="/login" />;
  }
  return null;
};

export default ProtectedRoute;
